/**
 * Get role based route
 * @param {object[]} routes routeconfig
 * @param {('admin' | 'client')} role
 * @return {object[]}
 */
const getAllowedRoutes = (routes, role) => {
  return routes.filter(route => {
    if (!route.permission) return true;
    if (route.permission.indexOf(role) !== -1) return true;
    return null;
  });
};
export default getAllowedRoutes;
